<template>
  <div class="row">
    <div class="col-7 grid-force-newlines">
      <FormRow label="Date">
        <FormDate v-model="internalDate" :minDate="minDate" :maxDate="maxDate" @input="updateDates()" />
      </FormRow>
    </div>
    <div class="col-5">
      <template>
        <FormButton class="btn-block btn-default btn-sm" @click="selectDateFilterToday" :disabled="!canSelectToday">Today</FormButton>
        <FormButton class="btn-block btn-default btn-sm" @click="selectDateFilterStartMonth" :disabled="!canSelectStartMonth">Start of Month</FormButton>
        <FormButton class="btn-block btn-default btn-sm" @click="selectDateFilterEndMonth" :disabled="!canSelectEndMonth">End of Month</FormButton>
        <FormButton class="btn-block btn-default btn-sm" data-toggle="dropdown" v-if="hasDropdownOptions"><i class="fas fa-caret-down"></i> More</FormButton>
        <ul class="dropdown-menu dropdown-menu-right">
          <DropdownMenuItem icon="fa-calendar-week" @click="selectDateFilterYesterday" v-if="canSelectYesterday">Yesterday</DropdownMenuItem>
          <DropdownMenuDivider v-if="canSelectYesterday" />
          <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterEndLastMonth" v-if="canSelectEndLastMonth">End of Last Month</DropdownMenuItem>
          <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterEndLastQuarter" v-if="canSelectEndLastQuarter">End of Last Quarter</DropdownMenuItem>
          <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterEndLastCalYear" v-if="canSelectEndLastCalYear">End of Last Calendar Year</DropdownMenuItem>
          <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterEndLastFinYear" v-if="canSelectEndLastFinYear">End of Last Financial Year</DropdownMenuItem>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ReportDateSelect',
  props: {
    minDate: String,
    maxDate: String,
    date: String,
  },
  computed: {
    canSelectToday() {
      return this._isDateAvailable(moment().local().startOf('day'))
    },
    canSelectYesterday() {
      return this._isDateAvailable(moment().local().subtract(1, 'day').startOf('day'))
    },
    canSelectStartMonth() {
      return this._isDateAvailable(moment().local().startOf('month'))
    },
    canSelectEndMonth() {
      return this._isDateAvailable(moment().local().endOf('month'))
    },
    canSelectStartYear() {
      return this._isDateAvailable(moment().local().startOf('year'))
    },
    canSelectEndLastMonth() {
      return this._isDateAvailable(moment().local().subtract(1, 'month').endOf('month'))
    },
    canSelectEndLastQuarter() {
      return this._isDateAvailable(moment().local().subtract(1, 'quarter').endOf('quarter'))
    },
    canSelectEndLastCalYear() {
      return this._isDateAvailable(moment().local().subtract(1, 'year').endOf('year'))
    },
    canSelectEndLastFinYear() {
      var quarterStart = moment().local().startOf('quarter')
      var curQtr = quarterStart.quarter()
      if(curQtr == 4)
        quarterStart = quarterStart.quarter(3)
      else if(curQtr <= 2)
        quarterStart = quarterStart.subtract(1, 'year').quarter(3)

      var finEnd = quarterStart.add(1, 'year').subtract(1, 'day').endOf('quarter')
      finEnd.subtract(1, 'year')

      return this._isDateAvailable(finEnd)
    },
    hasDropdownOptions() {
      return this.canSelectEndLastMonth || this.canSelectEndLastQuarter || this.canSelectEndLastCalYear || this.canSelectEndLastFinYear
    }
  },
  watch: {
    date: function() {
      this.$data.internalDate = moment(this.$props.date).toDate().toISOString()      
    },
  },
  data() {
    return {
      internalDate: moment(this.$props.date).toDate().toISOString(),
    }
  },
  methods: {
    selectDateFilterToday() {
      this.internalDate = moment().local().startOf('day').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterYesterday() {
      this.internalDate = moment().local().subtract(1, 'day').startOf('day').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterStartMonth() {
      this.internalDate = moment().local().startOf('month').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterEndMonth() {
      this.internalDate = moment().local().endOf('month').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterEndLastMonth() {
      this.internalDate = moment().local().subtract(1, 'month').endOf('month').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterEndLastQuarter() {
      this.internalDate = moment().local().subtract(1, 'quarter').endOf('quarter').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterEndLastCalYear() {
      this.internalDate = moment().local().subtract(1, 'year').endOf('year').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterEndLastFinYear() {
      var quarterStart = moment().local().startOf('quarter')
      var curQtr = quarterStart.quarter()
      if(curQtr == 4)
        quarterStart = quarterStart.quarter(3)
      else if(curQtr <= 2)
        quarterStart = quarterStart.subtract(1, 'year').quarter(3)

      var finEnd = quarterStart.add(1, 'year').subtract(1, 'day').endOf('quarter')
      finEnd.subtract(1, 'year')

      this.internalDate = finEnd.toDate().toISOString()
      this.updateDates()
    },

    updateDates() {
      // Clamp dates to min/max if set
      if(this.minDate) {
        if(moment(this.internalDate).isBefore(moment(this.minDate)))
          this.internalDate = moment(this.minDate).toDate().toISOString()
      }
      if(this.maxDate) {
        if(moment(this.internalDate).isAfter(moment(this.maxDate)))
          this.internalDate = moment(this.maxDate).toDate().toISOString()
      }

      this.$emit('updateDate', this.internalDate)
    },

    _isDateAvailable(selectDate) {
      if(this.minDate) {
        if(selectDate.isBefore(moment(this.minDate)))
          return false
      }
      if(this.maxDate) {
        if(selectDate.isAfter(moment(this.maxDate)))
          return false
      }

      return true
    }
  }
}
</script>